import * as React from "react";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "source/app/presentation/Shared/Render";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import { IsMasterDream } from "source/app/presentation/MainPanel/Dreams/DreamHelpers/IsMasterDream";
import { NavigateToDreamsRoute } from "../../Routing/DreamsRouting";

export function ShowCampaigns({ dreams }: { dreams: Dreams; }) {
    const campaignOnlyFilters = {
        ...clearedDreamFilters,
        onlyShowMasterDreams: true,
    };

    const numberOfCampaigns = dreams
        ? dreams.state.dreamsdata.filter((dream) => IsMasterDream(dream, dreams.state.dreamsdata)
        ).length
        : 0;

    return (
        <Render id="showFascinationsDreamsButton" when={numberOfCampaigns > 0}>
            <span id="showFascinations">
                <IconWithText
                    iconSuffix={EGlyphicon.tower}
                    whenClicked={() => {
                        NavigateToDreamsRoute(`Campaigns`);
                        dreams.setState(campaignOnlyFilters);
                    }}
                    displayAsBlock={false}
                >
                    {`${numberOfCampaigns} campaigns`}
                </IconWithText>
            </span>
        </Render>
    );
}
